import styled from 'styled-components';
import { TABLET } from '../../../../assets/variable';

export const Wrapper = styled.div`
	background: #ffffff;
	border: none;
	@media screen and (max-width: ${TABLET}) {
		margin-top: 20px;
	}
	.card {
		border: none;
		.thumbnailWrapper {
			border-radius: 8px;
			.thumbnail {
				height: 350px;
				width: 100%;
				border-radius: 8px;
				@media screen and (max-width: ${TABLET}) {
					height: 250px;
				}
			}
		}

		.card-block {
			@media screen and (max-width: ${TABLET}) {
				padding: 0 10px;
			}
			.card-title {
				margin-top: 26px;
				a {
					font-style: normal;
					font-weight: bold;
					font-size: 1.8rem;
					line-height: 140%;
					color: #4f4f4f;
					&:hover {
						text-decoration: none;
					}
				}
			}
			.card-desc {
				font-family: Merriweather, 'Times New Roman', Serif;
				font-style: normal;
				font-weight: normal;
				font-size: 16px;
				line-height: 150%;
				color: #4f4f4f;
				margin-top: 10px;
			}

			.footer-desc {
				margin-top: 10px;
				font-style: normal;
				font-weight: normal;
				font-size: 16px;
				line-height: 150%;
				color: #4f4f4f;
			}
		}
	}
`;

export default Wrapper;
